
import React from 'react';
import Layout from '@/components/Layout/Layout';
import FuelConsumptionConverter from '@/components/UnitConverter/FuelConsumptionConverter';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const FuelConsumptionConverterPage = () => {
  return (
    <Layout>
      <div className="container mx-auto max-w-3xl px-4">
        <div className="mb-6">
          <Link to="/converters" className="flex items-center text-primary hover:underline mb-2">
            <ArrowLeft size={16} className="mr-1" />
            Back to All Converters
          </Link>
          <h1 className="text-3xl font-bold mb-2">Fuel Consumption Converter</h1>
          <p className="text-gray-600 mb-6">
            Convert between different units of fuel consumption, from miles per gallon (MPG) to liters per 100km and more.
          </p>
        </div>
        
        <div className="mb-8">
          <FuelConsumptionConverter />
        </div>
        
        <div className="mt-10 prose max-w-none">
          <h2 className="text-xl font-semibold mb-4">About Fuel Consumption Converter</h2>
          <p>
            Our fuel consumption converter tool helps you convert between different units used to measure 
            vehicle fuel efficiency around the world. Fuel consumption can be expressed as distance per volume 
            (such as miles per gallon) or volume per distance (such as liters per 100 kilometers).
          </p>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Common Fuel Consumption Unit Conversions</h3>
          <p>
            Some of the most frequently used fuel consumption conversions include:
          </p>
          <ul className="list-disc ml-6">
            <li>Converting between miles per gallon (MPG) and liters per 100 kilometers (L/100km)</li>
            <li>Converting between US and Imperial (UK) gallons</li>
            <li>Converting between kilometers per liter (km/L) and miles per gallon (MPG)</li>
            <li>Converting between gallons per 100 miles and liters per 100 kilometers</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">Regional Differences</h3>
          <p>
            Different regions use different fuel consumption measurements:
          </p>
          <ul className="list-disc ml-6">
            <li>United States: Miles per gallon (MPG), using US gallons</li>
            <li>United Kingdom: Miles per gallon (MPG), using Imperial gallons</li>
            <li>Europe, Australia, and most of the world: Liters per 100 kilometers (L/100km)</li>
            <li>Japan and some other countries: Kilometers per liter (km/L)</li>
          </ul>
          
          <h3 className="text-lg font-medium mt-6 mb-2">How to Use the Fuel Consumption Converter</h3>
          <p>
            Using our fuel consumption converter is straightforward:
          </p>
          <ol className="list-decimal ml-6">
            <li>Enter the value you want to convert in the "From" field</li>
            <li>Select the fuel consumption unit you're converting from</li>
            <li>Select the fuel consumption unit you want to convert to</li>
            <li>The converted value will appear automatically</li>
          </ol>
          
          <p className="mt-6">
            Remember that lower values are better for distance-per-volume units like MPG and km/L 
            (higher efficiency), while higher values are worse for volume-per-distance units like L/100km 
            (lower efficiency). This is why the numbers go in opposite directions when comparing vehicles 
            using different measurement systems.
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default FuelConsumptionConverterPage;
